export const roleMenuList = {
  MANAGE: {
    CREATE_SHOTCLASS: "Create ShotClass",
    EDIT_SHOTCLASS: "Edit ShotClass",
  },
  SOCIAL: {
    POLL_MANAGEMENT: "Poll Management",
    FORUM_AREA: "Forum",
    MODERATE_CONTRIBUTION: "Moderate Shotclasses",
  },
  DISTRIBUTE: "Distribute ShotClass",
  REPORTS: "Report ShotClass",
  EVENTS: {
    VIRTUAL_QUIZ: "Virtual Quiz",
    LIVE_QUIZ: "Live Quiz",
  },
  ORGANIZE: {
    TOPIC_MANAGEMENT: "Topic Management",
    SERIES_MANAGEMENT: {
      CERETIFICATE_MANAGEMENT: "Certificate",
    },
  },
  ADMIN: {
    VIEW_ROLE_AND_PERMISSION: "View Role and permission",
    GROUP_MANAGEMENT: "User Group Management",
    MY_QUERIES: "Manage Queries For Admins",
    EMAIL_TRIGGER: "Email Trigger",
    ENGAGEMENT_CENTER: "Notification Management",
  },
};
